import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	TotalCurrency: {
		k: "checkout.total",
		v: "Total:  $"
	},

	CardNumber: {
		k: "checkout.cardNumber",
		v: "Card Number"
	},

	Purchase: {
		k: "checkout.purchase",
		v: "Purchase"
	},

	BulkDiscount: {
		k: "checkout.bulkDiscount",
		v: "See Bulk Pricing Discounts"
	},
	CheckoutEmpty: {
		k: "checkout.empty.title",
		v: "No details found in check out"
	},
	DescriptionEmpty: {
		k: "checkout.empty.description",
		v: "Please select a course for check out"
	}
});



// WEBPACK FOOTER //
// ./src/panels/checkout/CourseCheckout.label.ts